import {
  useMantineTheme,
  Container,
  Text,
  Title,
  Grid,
  Card,
  Image,
  Badge,
  Button,
  Group,
} from "@mantine/core";

const SectionFour = () => {
  const theme = useMantineTheme();

  return (
    <section id="section-four">
      <Container>
        <Text color="black" align="center">
          <Title order={1} mb="30px">
            Services
          </Title>
        </Text>

        <Grid>
          <Grid.Col xs={12} sm={4} md={4} lg={4}>
            <Card shadow="sm" p="lg" style={{ height: "100%" }}>
              <Card.Section>
                <Image src={require("../Images/image-2.png")} alt={"sample1"} />
              </Card.Section>

              <Group
                position="apart"
                style={{ marginBottom: 5, marginTop: theme.spacing.sm }}
              >
                <Text weight={500}>Connect with Medical Professionals</Text>
              </Group>

              <Text size="sm">
                Using our secure platform, easily connect with Medical
                Professionals and securely share your health information without
                any hassle. Get reliable and timely advice from experts in the
                field.
              </Text>

              {/* <Button variant="light" color="yellow" fullWidth mt="14px">
                Find out
              </Button> */}
            </Card>
          </Grid.Col>

          <Grid.Col xs={12} sm={4} md={4} lg={4}>
            <Card shadow="sm" p="lg" style={{ height: "100%" }}>
              <Card.Section>
                <Image src={require("../Images/image-4.png")} alt={"sample1"} />
              </Card.Section>

              <Group
                position="apart"
                style={{ marginBottom: 5, marginTop: theme.spacing.sm }}
              >
                <Text weight={500}>Machine Learning Diagnosis</Text>
              </Group>

              <Text size="sm">
                HealthShare's machine learning capabilities can analyze your
                health data to help identify potential health issues. You can
                receive faster and more effective treatment, leading to better
                health outcomes.
              </Text>

              {/* <Button variant="light" color="yellow" fullWidth mt="14px">
                Find out
              </Button> */}
            </Card>
          </Grid.Col>

          <Grid.Col xs={12} sm={4} md={4} lg={4}>
            <Card shadow="sm" p="lg" style={{ height: "100%" }}>
              <Card.Section>
                <Image src={require("../Images/image-3.png")} alt={"sample1"} />
              </Card.Section>

              <Group
                position="apart"
                style={{ marginBottom: 5, marginTop: theme.spacing.sm }}
              >
                <Text weight={500}>
                  A secure platform for Medical Professionals
                </Text>
              </Group>

              <Text size="sm">
                Medical Professionals can trust our secure platform for reliable
                and accurate information about a Patient’s health status,
                leading to improved care.
              </Text>

              {/* <Button variant="light" color="yellow" fullWidth mt="14px">
                Find out
              </Button> */}
            </Card>
          </Grid.Col>
        </Grid>
      </Container>
    </section>
  );
};

export default SectionFour;
